<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Store Gift
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="2">
              <v-autocomplete
                ref="gift"
                outlined
                v-model="form.gift_id"
                :items="giftItems"
                label="Gift"
                multiple
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.gift_id"
              ></v-autocomplete>
            </v-col>

            <v-col>
              <input
                type="checkbox"
                @change="selectAllGifts"
                v-model="is_select_all"
              />
              Select All Gifts
            </v-col>

            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.alloted_quantity"
                outlined
                label="Allotted Quantity"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.alloted_quantity"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.current_quantity"
                outlined
                label="Current Quantity"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.current_quantity"
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Map Gift
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "StoreGiftCreatePage",
  data() {
    return {
      form: {
        store_id: "",
        quantity: 0,
        gift_id: [],
      },
      storeItems: [],
      giftItems: [],
      isLoading: false,
      is_select_all: false,
    };
  },
  mounted() {
    this.form.store_id = this.decryptIt(this.$route.params.storeId);
    this.getData();
    // this.getMasters();
  },
  watch: {
    form: {
      deep: true,
      handler(newForm) {
        if (newForm.gift_id.length === 0) {
          this.is_select_all = false; // Uncheck when all selections are cleared
        }
      },
    },
  },
  methods: {
    getData() {
      let query = "store_id=" + this.form.store_id;
      console.log(query);

      axios
        .get(`/store_gifts?${query}`) // Query string ko proper format mein bhejna
        .then((response) => {
          this.store_gifts = response.data.data;
          console.log("storeGift", this.store_gifts);
          this.getMasters(); // getData ke baad getMasters call karein taaki data sync rahe
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getMasters() {
      await axios
        .get(`store_gifts/masters`)
        .then((masters) => {
          masters = masters.data;

          if (this.store_gifts.length === 0) {
            // Agar store gifts empty hai, toh saare gifts dikhao
            this.giftItems = masters.gifts.map((gift) => ({
              id: gift.id,
              text: gift.name,
              value: gift.id,
            }));
          } else {
            // Store Gifts IDs ko extract karna hai
            const storeGiftIds = this.store_gifts.map((gift) => gift.gift_id);
            console.log("storeGiftIds", storeGiftIds);

            // Filter gifts jo store gifts mein nahi hain
            this.giftItems = masters.gifts
              .filter((gift) => !storeGiftIds.includes(gift.id))
              .map((gift) => ({
                id: gift.id,
                text: gift.name,
                value: gift.id,
              }));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectAllGifts() {
      if (this.is_select_all) {
        this.form.gift_id = this.giftItems.map((gift) => gift.value); // Select all gifts
      } else {
        this.form.gift_id = []; // Clear selection
      }
    },
    async save() {
      try {
        console.log("gift_id", this.form.gift_id);

        this.isLoading = true;
        this.form.current_quantity = this.form.alloted_quantity;
        await axios.post("/store_gifts", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push(`/stores/${this.$route.params.storeId}/store-gifts`);
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
